module.exports = __webpack_public_path__ + "img/smoke-detector-lg.1fd02dcb.svg";